export const ToolsOptions = [
  { key: 'configuration', label: 'Konfiguration', icon: '/assets/img/ic-config-dock.svg' },
  { key: 'tasks', label: 'Aufgaben', icon: '/assets/img/ic-task-dock.svg' },
  { key: 'changes', label: 'Änderungen', icon: '/assets/img/ic-changes-dock.svg' },
  { key: 'orders', label: 'Bestellungen', icon: '/assets/img/ic-orders-dock.svg' },
  { key: 'corrections', label: 'Nachbesserung', icon: '/assets/img/ic-files-dock.svg' },
  { key: 'team', label: 'Team', icon: '/assets/img/ic-team-dock.svg' },
  { key: 'contacts', label: 'Kontakte', icon: '/assets/img/ic-contacts-dock.svg' },
  { key: 'calendar', label: 'Kalender', icon: '/assets/img/ic-calendar-dock.svg' },
  { key: 'email', label: 'E-Mail', icon: '/assets/img/ic-email-dock.svg' },
  { key: 'logbook', label: 'Logbuch', icon: '/assets/img/ic-logbook.svg' }
];
